import Heart from '@assets/icons/Heart';
import { LovedLabelText, LovedLabelWrapper } from './lovedLabel.styled';
import { useACF } from '@context/ACFContext';

const LovedLabel = ({ marginTop }: { marginTop?: string }) => {
	const { postTemplate } = useACF();

	const mainProduct = postTemplate?.review_page_v4_products_section_settings?.main_product;
	if (!mainProduct) return null;

	return (
		<LovedLabelWrapper marginTop={marginTop}>
			<Heart />
			<LovedLabelText>{mainProduct?.tr_people_bought_this_week_label}</LovedLabelText>
		</LovedLabelWrapper>
	);
};

export default LovedLabel;
